import type { FlowState } from "./types";

interface ValidationStepProps {
  state: FlowState;
  onBack: () => void;
  onStart: () => void;
}

export function ValidationStep({ state, onBack, onStart }: ValidationStepProps) {
  const blocking = state.issues.filter((item) => item.blocking);
  const warnings = state.issues.filter((item) => !item.blocking);
  return (
    <section className="flow-panel" aria-labelledby="validation-title">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">第 2 步</span>
          <h2 id="validation-title">导入校验结果</h2>
        </div>
        <span className={blocking.length ? "status-pill danger" : "status-pill success"}>
          {blocking.length ? `${blocking.length} 个阻塞错误` : "可以生成周报"}
        </span>
      </div>
      {blocking.length > 0 && (
        <div className="alert error" role="alert">
          <strong>生成已阻止</strong>
          <span>请修复以下文件问题后重新上传；平台没有写入任何半成品。</span>
        </div>
      )}
      {warnings.length > 0 && (
        <div className="alert warning">
          <strong>发现 {warnings.length} 个可降级问题</strong>
          <span>相关 SKU 会明确显示为 insufficient_data，其余 SKU 可继续分析。</span>
        </div>
      )}
      <div className="validation-list">
        {state.issues.length === 0 && <p>模板、字段、日期、币种、粒度和 SKU 集合均通过。</p>}
        {state.issues.map((issue, index) => (
          <article key={`${issue.code}-${index}`}>
            <span className={issue.blocking ? "issue-marker blocking" : "issue-marker"} />
            <div>
              <strong>{issue.message}</strong>
              <small>
                {issue.report_type} · {issue.code}
                {issue.entity_key ? ` · ${issue.entity_key}` : ""}
                {issue.field ? ` · ${issue.field}` : ""}
              </small>
            </div>
          </article>
        ))}
      </div>
      {state.error && <div className="alert error" role="alert">{state.error}</div>}
      <div className="flow-actions">
        <button className="secondary-button" onClick={onBack} type="button">重新选择文件</button>
        <button disabled={blocking.length > 0 || state.busy || !state.reportSet} onClick={onStart} type="button">
          {state.busy ? "正在创建运行…" : "生成确定性周报"}
        </button>
      </div>
    </section>
  );
}
